"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containsSuperCall = containsSuperCall;
exports.ensureConstructor = ensureConstructor;
exports.bindMethodsInConstructor = bindMethodsInConstructor;
exports.bindMethods = bindMethods;

var _types = require("../types");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// prevent generated spreadexpr from being further transformed
function safe(node) {
  node._safe = true;
  return node;
} // Check if the given path or any of its descendants contains a `super()`
// call expression.
function containsSuperCall(path) {
  var hasSuper = false;
  path.traverse({
    noScope: true,

    Class(path) {
      path.skip();
    } // XXX: this may not be necessary due to super calls in free functions
    // being syntax errors caught by js engine.
    , Function(path) {
      path.skip();
    }, Super(superPath) {
      if ((0, _types.is)("CallExpression", superPath.parentPath)) {
        hasSuper = true;
        superPath.stop();
      }
    } });
  return hasSuper;
} // Ensure that a class body has a constructor, optionally ensuring that
// the constructor itself has a `super(...args)` call.
//
// TODO: consider refactoring here
// - "hasConstructor" function to look for the constructor with traverse()
// - "addEmptyConstructor" to make the empty constructor
// - "addSuperCallToConstructor" to make the supercall.
function ensureConstructor(classPath, constructorBodyPath) {
  var withSuper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!constructorBodyPath) {
    var emptyConstructor = _types2.default.classMethod("constructor", _types2.default.identifier("constructor"), [], _types2.default.blockStatement([]));
    // XXX: this marks this constructor for super insertion.
    // why is it doing it like this? seems hackish, rethink
    emptyConstructor.skinny = true;
    classPath.get("body").unshiftContainer("body", emptyConstructor);
    constructorBodyPath = classPath.get("body.body.0.body");
  }if (withSuper && classPath.node.superClass && constructorBodyPath.parentPath.node.skinny && !containsSuperCall(constructorBodyPath)) {
    var superCall = constructorBodyPath.parentPath.node.params.length ? _types2.default.expressionStatement(_types2.default.callExpression(_types2.default.super(), constructorBodyPath.parentPath.node.params)) : function () {
      // constructor(...args) -> super(...args)
      var argsUid = classPath.scope.generateUidIdentifier("args");
      constructorBodyPath.parentPath.node.params = [_types2.default.restElement(argsUid)];
      return _types2.default.expressionStatement(_types2.default.callExpression(_types2.default.super(), [safe(_types2.default.spreadElement(argsUid))]));
    }();constructorBodyPath.unshiftContainer("body", superCall);
  }return constructorBodyPath;
} // Insert code into class constructor which will autobind a list of class
// methods at construction time.
function bindMethodsInConstructor(classPath, constructorPath, methodIds) {
  // `this.method = this.method.bind(this);`
  var assignments = function () {
    var _arr = [];for (var _i2 = 0, _len2 = methodIds.length; _i2 < _len2; _i2++) {
      var _methodId = methodIds[_i2];
      _types2.default.assertOneOf(_methodId, ["Identifier", "Expression"]);
      var isComputed = !(0, _types.is)("Identifier", _methodId);

      var thisDotMethod = _types2.default.memberExpression(_types2.default.thisExpression(), _methodId, isComputed);

      _arr.push(_types2.default.expressionStatement(_types2.default.assignmentExpression("=", thisDotMethod, _types2.default.callExpression(_types2.default.memberExpression(thisDotMethod, _types2.default.identifier("bind")), [_types2.default.thisExpression()]))));
    }return _arr;
  }();

  // directly after each instance of super(), insert the thingies there.
  if (classPath.node.superClass) {
    return constructorPath.traverse({
      Super(superPath) {
        if (!superPath.parentPath.isCallExpression()) return;
        var superStatementPath = superPath.getStatementParent();

        // things get super weird when you return super();
        // TODO: consider trying to handle it
        var enclosingReturn = superPath.findParent(function (p) {
          return p.isReturnStatement() && p.getFunctionParent() === constructorPath.parentPath;
        });
        if (enclosingReturn) throw new Error("Can't use => with `return super()`; try removing `return`.");

        superStatementPath.insertAfter(assignments);
        return;
      }
    });
  } else {
    return constructorPath.unshiftContainer("body", assignments);
  }
}function bindMethods(path, methodIds) {
  var assignId = void 0,
      inExpression = false;
  if (path.isClassDeclaration()) {
    assignId = path.node.id;
  } else if (path.parentPath.isAssignmentExpression() && path.parentPath.parentPath.isExpressionStatement()) {
    assignId = path.parentPath.node.left;
  } else if (path.parentPath.isVariableDeclarator()) {
    assignId = path.parentPath.node.id;
  } else {
    var id = path.isClass() ? "class" : "obj";
    assignId = path.getStatementParent().scope.generateDeclaredUidIdentifier(id);
    inExpression = true;
  }
  _types2.default.assertOneOf(assignId, ["Identifier", "MemberExpression"]);

  var assignments = methodIds.map(function (methodId) {
    // could be computed, eg `['blah']() => {}`
    _types2.default.assertOneOf(methodId, ["Identifier", "Expression"]);
    var isComputed = !_types2.default.isIdentifier(methodId);
    var objDotMethod = _types2.default.memberExpression(assignId, methodId, isComputed);
    var bind = _types2.default.callExpression(_types2.default.memberExpression(objDotMethod, _types2.default.identifier("bind")), [assignId]);
    return _types2.default.assignmentExpression("=", objDotMethod, bind);
  });

  if (inExpression) {
    return path.replaceWith(_types2.default.sequenceExpression([_types2.default.assignmentExpression("=", assignId, path.node)].concat(_toConsumableArray(assignments), [assignId])));
  } else {
    return path.getStatementParent().insertAfter(assignments.map(function (a) {
      return _types2.default.expressionStatement(a);
    }));
  }
}